import Fuse from 'fuse.js'

export const getSearchConfiguration = (allJobs) => {
    return new Fuse(allJobs, {
        keys: ['function.label', 'location.city', 'name', 'COUNTRY.label'],
        threshold: 0.2,
        ignoreLocation: true,
    })
}
